function newRenderFreeGiftReward (cartGoalIndex) {
        const tlCartGoalLocalStorage = JSON.parse(localStorage.getItem(LOCAL_STORAGE));
        const passedFreeGift = window.tlCartGoalEmbed.passedMilestone.gift;
        const aplliedFreeGift = tlCartGoalLocalStorage.gift >= passedFreeGift;
        const cartTotal = window.tlCartGoalEmbed.cartTotal;
        let giftItemHTML = "";
        let giftVariants = window.tlCartGoalEmbed.gifts[window.tlCartGoalEmbed.passedMilestone.indexOfPassedFreeGift];
        giftVariants.map((variant, variantIndex) => {
            giftItemHTML += `
                <div class="tl__cart-goal__free-gift-reward-body">
                    <div style="display: flex; gap: 5px">
                        <img class="tl__cart-goal__product-image" src="${
                            variant.featured_image.src || variant.featured_image
                        }" alt="product-image"/>
                        <div class="tl__cart-goal__product-image-info">
                            <p>${variant.name}</p>
                            <span><del>${window.tlCartGoalEmbed.formatMoney(
                                variant.price,
                                window.tlCartGoalEmbed.cartGoal.currency_format,
                                window.tlCartGoalEmbed.cartGoal.currency_display,
                            )}</del></span>
                            <span>${window.tlCartGoalEmbed.translation.gift_modal.free_text_content}</span>
                            <span>${
                                window.tlCartGoalEmbed.milestones[passedFreeGift].specific_quantity
                                    ? "x" +
                                      variant.specificQuantity +
                                      `${variant.specificQuantity > 1 ? " items" : " item"}`
                                    : "x1 item"
                            }</span>
                        </div>
                    </div>
                    <div class="tl__cart-goal__check-box tl__cart-goal__check-box-${passedFreeGift} tl__cart-goal__check-box-${passedFreeGift}-${variantIndex}"
                    onClick="window.tlCartGoalEmbed.handleChangeGift(${passedFreeGift}, ${variantIndex})" tl__cart-goal_data_id=${
                variant.id
            }></div>
                </div>
            `;
        });
    
        const arrTypeGift = window.tlCartGoalEmbed.milestones.filter((milestone) => {
            return milestone.reward_type === "gift" && milestone.cart_value < cartTotal;
        });
        const result = arrTypeGift.map((item) => {
            const milestone = item;
            const afterAchieve = window.tlCartGoalEmbed.replaceVariables(milestone.reward_description_after, milestone);
            return (
                `
            <div style="display: flex; width: 100%;justify-content: space-between;">
                <div style="width: 60%">
                    <p style="margin: 0px; padding: 0px; font-weight: bold; font-size: 14px">${milestone.title}</p>
                    <p style="margin: 0px; padding: 0px; font-size: 12px; margin-bottom: 5px">${afterAchieve}</p>
                </div>
                ` +
                `
                ${
                    window.tlCartGoalEmbed.cartGoal.auto_add_reward && giftVariants.length
                        ? aplliedFreeGift
                            ? `<div style="background: ${window.tlCartGoalEmbed.sectionRewardStyle.button_selected_color}" class="tl__cart-goal__gift-noti">
                    ${window.tlCartGoalEmbed.translation.auto_apply_btn.gift}
                </div>`
                            : ``
                        : `<div style="background: ${
                              aplliedFreeGift
                                  ? "var(--tl__cart-goal__section-reward__button-selected-color)"
                                  : "var(--tl__cart-goal__section-reward__button-color)"
                          }" class="tl__cart-goal__gift-noti" onclick="window.tlCartGoalEmbed.toggleGifts(${cartGoalIndex})">
                    <span>
                        ${
                            aplliedFreeGift
                                ? `${window.tlCartGoalEmbed.translation.manual_apply_btn.gift.after_apply}`
                                : `${window.tlCartGoalEmbed.translation.manual_apply_btn.gift.before_apply}`
                        }
                    </span>
                </div>`
                }
                ` +
                `
            </div>
            <div class="tl__cart-goal__gift-modal-${cartGoalIndex}">
            ${
                giftVariants.length !== 0
                    ? `<div class="tl__cart-goal__list-gifts tl__cart-goal__list-gifts-${passedFreeGift}">
                            <span style="font-weight: 500">${window.tlCartGoalEmbed.translation.gift_modal.title.replace(
                                "{{amount}}",
                                `${window.tlCartGoalEmbed.milestones[passedFreeGift].reward_value}`,
                            )} <span class="tl_selected_quantity"></span></span>
                            <div style="max-height: 300px; overflow-y: auto; width: 100%">
                            ${giftItemHTML}
                            </div>
                            <div id="salepify-cart-goal-block-error"></div>
                            <div style="display: flex; width: 100%;height: 60px">
                                <div class="tl__cart-goal__button-cancel-gift" onclick="window.tlCartGoalEmbed.toggleGifts(${cartGoalIndex}, false)">
                                ${window.tlCartGoalEmbed.translation.gift_modal.cancel_btn}
                                </div>
                                <div class="tl__cart-goal__button-add-gift" onclick="(()=>{window.tlCartGoalEmbed.handleAddtoCart(${passedFreeGift}, ${cartGoalIndex}) ; ${(window.tlCartGoalEmbed.isClickButtonConfirm = true)}})()">
                                ${window.tlCartGoalEmbed.translation.gift_modal.confirm_btn}
                                </div>
                            </div>
                        </div>`
                    : `<div class="tl__cart-goal__list-gifts">
                            <span style="font-weight: 600">Sorry, but there's no gift available</span>
                            <div style="display: flex; width: 100%;height: 60px">
                                <div class="tl__cart-goal__button-cancel-gift" style="width: 100%;" onclick="window.tlCartGoalEmbed.toggleGifts(${cartGoalIndex}, false)">
                                    ${window.tlCartGoalEmbed.translation.gift_modal.cancel_btn}
                                </div>
                            </div>
                        </div>`
            }
            </div>
            <hr style="margin: 5px 0px; width: 100%; height: 1px"/>
        `
            );
        });
        return result.join("");
}

function newRenderCartGoal (cartGoalIndex) {

    const hasDefaultCart = document.querySelector(window.tlCartGoalEmbed.defaultCartSelector) !== null;
    const hasDefaultProductPage = document.querySelector(window.tlCartGoalEmbed.defaultProductPageSelector) !== null;
    const hasCustomDisplay = window.tlCartGoalEmbed.cartDrawDisplay.selector || window.tlCartGoalEmbed.cartDisplay.selector || window.tlCartGoalEmbed.productPageDisplay.selector;
    if (hasDefaultCart || hasDefaultProductPage || hasCustomDisplay) {
        let milestonesHTMLInCartDrawer = ``;
        let closestGoal = -1;
        let isCartDiscount = 0;
        let marginValues = window.tlCartGoalEmbed.getCartGoalsMarginValues();
        window.tlCartGoalEmbed.milestones.map((milestone, index) => {
            if (closestGoal === -1 && milestone.cart_value > window.tlCartGoalEmbed.cartTotal) {
                closestGoal = index;
            }

            let imgSrc =
                milestone.reward_type == window.tlCartGoalEmbed.CART_GOAL_REWARD_TYPE.FREE_GIFT
                    ? window.tlCartGoalEmbed.giftSVG
                    : milestone.reward_type == window.tlCartGoalEmbed.CART_GOAL_REWARD_TYPE.CART_DISCOUNT
                    ? window.tlCartGoalEmbed.discountSVG
                    : window.tlCartGoalEmbed.freeShippingSVG;

            // if(milestone.title === "Livraison OFFERTE"){
            let customTitle = milestone.title;
            if (index === 0) {
                isCartDiscount = 1;
                imgSrc =
                    "https://cdn.shopify.com/s/files/1/0653/0265/9288/files/pictos-reassurance-carre_hn4pa8.jpg?v=1741861643";
                customTitle = "Livraison<br>OFFERTE";
            }
            // if(milestone.title === "1 mini huile d'amande OFFERTE"){
            if (index === 1) {
                isCartDiscount = 1;
                imgSrc = PRODUCT_GIFT_IMG
                customTitle = "1 mini huile<br>OFFERTE";
            }
            // if(milestone.title === "1 thé Cosmic Dealer OFFERTE"){
            if (index === 2) {
                isCartDiscount = 1;
                imgSrc = "https://cdn.shopify.com/s/files/1/0653/0265/9288/files/ByzantinexWildApothecary-Petitepochetteplate.jpg?v=1764666916";
                customTitle = "1 pochette <br>OFFERTE";
            }
            milestonesHTMLInCartDrawer += `
                <div class="tl__cart-goal__goal-check-point__drawer" 
                    style="margin-left: ${marginValues[index]}%;
                    z-index: 1;
                    border-color: ${(() =>
                        window.tlCartGoalEmbed.cartTotal >= milestone.cart_value
                            ? "var(--tl__cart-goal__filled-bar-color)"
                            : "black")()}"
                >
                    <p class="tl__cart-goal__goal-check-point-value" 
                        style="color: var(--tl__cart-goal__milestone-label-color); 
                        visibility: ${index === closestGoal ? "visible" : ""}"
                    >
                        ${window.tlCartGoalEmbed.formatMoney(
                            milestone.cart_value * 100,
                            window.tlCartGoalEmbed.currencyFormat,
                            window.tlCartGoalEmbed.currencyDisplay,
                        )}
                    </p>
                        <div
                            style="
                            width: 50px;
                            height: 50px;
                            background-color: #F5F7FB;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            border-radius: 50%;
                            "
                        >
                            <img
                            src="${imgSrc}"
                            alt="tl-cart-goal"
                            style="
                                width: 100%;
                                height: 100%;
                                object-fit: contain;
                                object-position: center;
                                border-radius: 50%;
                            "
                            />
                        </div>
                            
                    <p class="tl__cart-goal__goal-check-point-title" 
                        style="min-height: 25px; color: var(--tl__cart-goal__milestone-label-color);text-align:center; 
                        visibility: ${index === closestGoal ? "visible" : ""}; margin-right: ${
                index === 2 ? "40px" : "0"
            }; "
                    >${customTitle}</p>
                </div>
            `;
        });
        let trademarkHTMLInCartDrawer = window.tlCartGoalEmbed.showTrademark
            ? `
            <p
                style="
                    display: block !important;
                    visibility: visible !important;
                    opacity: 1 !important;
                    position: static !important;
                    transform: none !important;
                    clip-path: none !important;
                    overflow: visible !important;
                    width: auto !important;
                    height: auto !important;
                    max-width: none !important;
                    max-height: none !important;
                    background: none !important;
                    color: #000 !important;
                    font-size: 12px !important;
                    text-align: center !important;
                    margin: 0 !important;
                "
            >
                Powered by 
                <a
                    href="https://apps.shopify.com/partners/tek-labs" 
                    target="_blank"
                    style="
                        display: inline !important;
                        visibility: visible !important;
                        opacity: 1 !important;
                        position: static !important;
                        transform: none !important;
                        clip-path: none !important;
                        overflow: visible !important;
                        width: auto !important;
                        height: auto !important;
                        max-width: none !important;
                        max-height: none !important;
                        background: none !important;
                        color: #000 !important;
                        font-size: 12px !important;
                        text-align: center !important;
                        cursor: pointer !important;
                        text-decoration: underline !important;
                    "
                >
                    Salepify App
                </a>
            </p>
            `
            : "";
        let cartGoalHTMLInCartDrawer = `
            <div class="tl__cart-goal__container__drawer">
                <p class="tl__cart-goal__reward-description__drawer">${window.tlCartGoalEmbed.getLeftAmountText(
                    window.tlCartGoalEmbed.milestones[closestGoal],
                )}</p>
                <div class="tl__cart-goal__goal-container__drawer">
                    <div class="tl__cart-goal__goal-process__drawer" style="display: block; width: ${window.tlCartGoalEmbed.getProcessBarWidth()}%"></div>
                    ${milestonesHTMLInCartDrawer}
                </div>
                <hr style="margin: 5px 0px; width: 100%; height: 1px"/>
                <div class="tl__cart-goal__free-gift-container-${cartGoalIndex}" style="width: 100%; color: #303030">
                    ${window.tlCartGoalEmbed.renderReward(cartGoalIndex)}
                </div>
                ${trademarkHTMLInCartDrawer}
            </div>
        `;

        return cartGoalHTMLInCartDrawer;
    }
}

function newRenderReward (cartGoalIndex) {
    let innerHTML = "";
    if (!window.tlCartGoalEmbed.sectionRewardStyle.hide_claim_reward) {
        const { ALL_MILESTONES } = window.tlCartGoalEmbed.CART_GOAL_REWARD_STACK;
        const { FREE_SHIPPING, FREE_GIFT } = window.tlCartGoalEmbed.CART_GOAL_REWARD_TYPE;
        if (window.tlCartGoalEmbed.cartGoal.reward_stack == ALL_MILESTONES) {
            const shippingRewardHTML =
                window.tlCartGoalEmbed.passedMilestone.freeShipping !== -1
                    ? window.tlCartGoalEmbed.renderShippingReward()
                    : "";
            const cartDcRewardHTML =
                window.tlCartGoalEmbed.passedMilestone.discount !== -1
                    ? window.tlCartGoalEmbed.renderCartDcReward()
                    : "";
            const freeGiftRewardHTML =
                window.tlCartGoalEmbed.passedMilestone.gift !== -1
                    ? window.tlCartGoalEmbed.renderFreeGiftReward(cartGoalIndex)
                    : "";

            innerHTML = `
                ${shippingRewardHTML}
                    
                ${cartDcRewardHTML}
            `;
            // ${freeGiftRewardHTML}
        } else if (window.tlCartGoalEmbed.passedMilestone.lastest !== -1) {
            const lastestMileStoneIdx = window.tlCartGoalEmbed.passedMilestone.lastest;
            const lastestMileStone = window.tlCartGoalEmbed.milestones[lastestMileStoneIdx];
            innerHTML =
                lastestMileStone.reward_type == FREE_SHIPPING
                    ? window.tlCartGoalEmbed.renderShippingReward()
                    : lastestMileStone.reward_type == FREE_GIFT
                    ? window.tlCartGoalEmbed.renderFreeGiftReward(cartGoalIndex)
                    : window.tlCartGoalEmbed.renderCartDcReward();
        }
    }
    return innerHTML;
};
// const intervalId = setInterval(() => {
//     if (window.tlCartGoalEmbed) {
//         clearInterval(intervalId);
//         window.tlCartGoalEmbed.renderFreeGiftReward = newRenderFreeGiftReward;
//         window.tlCartGoalEmbed.renderCartGoal = newRenderCartGoal;
//         window.tlCartGoalEmbed.renderReward = newRenderReward;
//         console.log("custom-progress-bar-salepify done");
//     }
// }, 15);
    
// setTimeout(() => {
//     clearInterval(intervalId);
// }, 5000);


(function() {
    let obj;
 
    Object.defineProperty(window, "tlCartGoalEmbed", {
        get() {
            return obj;
        },
        set(val) {
            if (val && !obj) {
                val.getMilestoneIcon = function (milestone) {
                    const iconTypeMap = {
                        [window.tlCartGoalEmbed.CART_GOAL_REWARD_TYPE.FREE_GIFT]: "free_gift",
                        [window.tlCartGoalEmbed.CART_GOAL_REWARD_TYPE.CART_DISCOUNT]: "discount",
                        [window.tlCartGoalEmbed.CART_GOAL_REWARD_TYPE.FREE_SHIPPING]: "shipping"
                    };

                    const iconConfig = {
                        [window.tlCartGoalEmbed.CART_GOAL_REWARD_TYPE.FREE_GIFT]: window.tlCartGoalEmbed.giftSVG,
                        [window.tlCartGoalEmbed.CART_GOAL_REWARD_TYPE.CART_DISCOUNT]: window.tlCartGoalEmbed.discountSVG,
                        [window.tlCartGoalEmbed.CART_GOAL_REWARD_TYPE.FREE_SHIPPING]: window.tlCartGoalEmbed.freeShippingSVG
                    };

                    const fileUrl = window.tlCartGoalEmbed.icons?.[iconTypeMap[milestone.reward_type] || "free_gift"]?.url || "";
                    const isCustom = false;
                    const isCustomImage = false;

                    const index = window.tlCartGoalEmbed.milestones.findIndex(item => item.cart_value == milestone.cart_value)
                    
                    let imgSrc = iconConfig[milestone.reward_type] || window.tlCartGoalEmbed.giftSVG;
                    let customTitle = milestone.title;
                    if (index === 0) {
                        isCartDiscount = 1;
                        imgSrc = "https://cdn.shopify.com/s/files/1/0653/0265/9288/files/pictos-reassurance-carre_hn4pa8.jpg?v=1741861643";
                    } else if (index === 1) {
                        isCartDiscount = 1;
                        imgSrc = PRODUCT_GIFT_IMG
                    } else if (index === 2) {
                        isCartDiscount = 1;
                        imgSrc = "https://cdn.shopify.com/s/files/1/0653/0265/9288/files/ByzantinexWildApothecary-Petitepochetteplate.jpg?v=1764666916";
                    }

                    return { isCustom, isCustomImage, imgSrc };
                };

                val.renderFreeGiftReward = newRenderFreeGiftReward;
                val.renderCartGoal = newRenderCartGoal;
                val.renderReward = newRenderReward;
                obj = val;
            }
 
        },
        configurable: true
    });
})();